import { Modal } from 'antd';

import { useMigrateHotel } from 'app/hooks/data/core/admin/hotels/useMigrateHotel';
import type { Hotel } from 'app/typings/hotels/Hotel/Hotel';

import styles from './MigrateModal.module.scss';

type MigrateModalProps = {
  open: boolean;
  onClose: () => void;
  hotel: Hotel;
};

export const MigrateModal = ({ open, onClose, hotel }: MigrateModalProps) => {
  const { mutateAsync: migrateHotel, isLoading: isMigrating } =
    useMigrateHotel();

  const handleOk = async () => {
    await migrateHotel({ hotelId: hotel.id });

    onClose();
  };

  return (
    <Modal
      title="Migrate hotel to the new data model?"
      open={open}
      width={572}
      closable={!isMigrating}
      maskClosable={!isMigrating}
      destroyOnClose
      onCancel={onClose}
      onOk={handleOk}
      confirmLoading={isMigrating}
      cancelButtonProps={{ disabled: isMigrating }}
      okText="Migrate hotel"
      centered
      className={styles.migrateHotelModal}
    >
      <div className={styles.migrateHotelModalContent}>
        <p>
          Are you sure you want to migrate this hotel to the new data model?
        </p>
        <br />
        <p>This action will migrate :</p>
        <ul>
          <li>
            all published night packages, including their associated rooms and
            activities.
          </li>
          <li>
            all published day packages,{' '}
            <strong>excluding their associated activities.</strong>
          </li>
        </ul>
        <p>This action cannot be undone.</p>
      </div>
    </Modal>
  );
};
